<template>
<div class="w-100 pt-3">
    <p v-show="false">{{$ml.get('SELECT')}}：{{ name }}</p>
    <ve-pie
      :colors="colors"
      :data="chartData"
      :settings="chartSettings"
      :events="chartEvents">
    </ve-pie>
    
  </div>
</template>

<style>
/**
 * The default size is 600px×400px, for responsive charts
 * you may need to set percentage values as follows (also
 * don't forget to provide a size for the container).
 */
.echarts {
  width: 100%;
  height: 100%;
}
</style>
<script>
import VePie from 'v-charts/lib/pie.common'
export default {
    props:["data","color"],
    data () {
      this.chartSettings = {
        selectedMode: 'single',
        hoverAnimation: true,
        fontSize:'40px'
      }
      var self = this
      this.chartEvents = {
        click: function (e) {
          self.name = e.name
            //alert(e.value)
        }
      }
      return {
        
        chartData: {
          columns: ['name', 'value'],
          rows: []
        },
        colors: [],
        name: '',
        loading: true
      }
    },
    watch:{
        data:{
            handler(){
                this.chartData={}
                this.chartData={
                  columns: ['name', 'value'],
                  rows: this.data
                }
                this.colors=this.color
            },
            deep:true
        }
    },
    components: { VePie }
  }
</script>